
import React from 'react';

import { TabsPanel } from '../../core';
import { getTabWidth as getTabWidthData } from '../../data';
import { getTabWidth as getTabWidthMeasurement } from '../../measurement';

const TabPanelsViewer = ({
    appActions,
    appConfig,
    additionalContent,
    layoutValues,
    map,
    mapActions,    
    onObjectInfo,
    tabs,
    uiValues
}) => {

    const getActivePanelName = () => {
        let activePanelName = uiValues['activePanelName']; 
        if (!activePanelName) {
            activePanelName = tabs[0].name;
        }

        return activePanelName;
    }

    const setActivePanel = (name) => {
        if (appActions) {
            appActions.setUiValue('activePanelName', name);
        }
    }

    const existsTab = (name, tabs) => {
        return tabs.reduce((previous, current) => {
            return (current.name === name)
                ? true
                : previous;
        }, false);
    }

    const getMinWidth = (tabs) => {
        let width = 300;
        if (existsTab('data', tabs)) {
            width = Math.max(width, getTabWidthData());
        }
        if (existsTab('measurement', tabs)) {
            width = Math.max(width, getTabWidthMeasurement());
        }
        return width;
    }

    const activePanelName = getActivePanelName();
    let tabSide = layoutValues['layersPanelPosition'];

    return (
        <TabsPanel
            active={activePanelName}
            additionalContent={additionalContent}
            tabSide={tabSide}
            setActivePanel={setActivePanel}
            styles={{root: {width: layoutValues['tabPanelsWidth'] || getMinWidth(tabs)}}}
        >
            {tabs.map(item => {
                return item.renderTabPanelFunc({
                    ...item, 
                    appActions, 
                    appConfig,
                    layoutValues, 
                    map, 
                    mapActions,                    
                    onObjectInfo,
                    uiValues, 
                    key: item.name
                });
            })}
        </TabsPanel>
    );
}

export default TabPanelsViewer;
